// Theme colors change extremely rarely (admin "set and forget").
// Strategy: trust Turbo's cached snapshot 100% of the time UNLESS the new page
// carries a different theme fingerprint. When fingerprints match (almost always),
// Turbo shows the cache instantly with zero work here — no flash, no repaint.
// When fingerprints differ (colors just changed), apply the new CSS vars before
// Turbo swaps the body so the correct colors appear immediately.

document.addEventListener("turbo:before-render", (event) => {
  const currentFingerprint = document.body.dataset.theme
  const incomingFingerprint = event.detail.newBody.dataset.theme

  if (currentFingerprint === incomingFingerprint) return

  // Theme changed — extract and apply new CSS vars before the swap
  const styleEl = event.detail.newBody.querySelector("style[data-site-theme]")
  if (!styleEl) return

  const text = styleEl.textContent
  const match = text.match(/:root\s*\{([^}]+)\}/)
  if (!match) return

  const root = document.documentElement
  match[1].split(";").forEach((decl) => {
    const [prop, val] = decl.split(":").map((s) => s.trim())
    if (prop && val) root.style.setProperty(prop, val)
  })
})
